import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from 'react-data-table-component';
import { FileText, Search } from "lucide-react";
import { getPresupuestos } from "../../constants/comprobantes";

const formatFecha = (fechaStr) => {
  if (!fechaStr) return '';
  const date = new Date(fechaStr);
  // Ajuste: a veces la fecha viene como string SQL y Date la toma en UTC
  if (isNaN(date)) return fechaStr; // si no puede parsear, devuelve el texto original
  return date.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const formatMoneda = (valor) => {
  if (!valor) return '0,00';
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 2,
  }).format(parseFloat(valor));
};

const customStyles = {
  headCells: {
    style: {
      backgroundColor: '#007bff', // color de fondo del header
      color: 'white',             // color del texto
      fontWeight: 'bold',
      fontSize: '14px',
      textTransform: 'uppercase',
    },
  },
  cells: {
    style: {
      padding: '8px 12px',
    },
  },
};

function TablaComprobantes() {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();    
    const [comprobantes, setComprobantes] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [loadingPdf, setLoadingPdf] = useState(true);

    useEffect(() => {
    const fetchData = async () => {
        const loggedUserData = JSON.parse(localStorage.getItem("user"));

        if (loggedUserData && loggedUserData.data && loggedUserData.data.user) {
            setUser(loggedUserData.data.user);
        } else {
            navigate("/signin");
        }

      try {
        const nrocli = (loggedUserData.data.cliente.nrocli == undefined ? '' : loggedUserData.data.cliente.nrocli);
        const grupo = 'P';

        const data = await getPresupuestos(nrocli, grupo);

        if (data.data) {
          // Convertimos el objeto (que tiene claves 0,1,2,...,cantidad)
          const lista = Object.values(data.data).filter(
            c => typeof c === 'object' && !Array.isArray(c)
          );

          setComprobantes(lista);
        }
      } catch (error) {
        console.error('Error cargando presupuestos:', error);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
    }, []);

    const columns = [
        { name: 'Comprobante', selector: row => row.comprobante, sortable: true },
        { name: 'Fecha', selector: row => row.fecha, format: (row) => formatFecha(row.fecha), sortable: true },
        { name: 'Cliente', selector: row => row.nomcli, sortable: true },
        { name: 'Vendedor', selector: row => row.Vendedor, sortable: true },
        { name: 'Total', selector: row => formatMoneda(row.total), right: true, sortable: true },
        { name: 'Estado', selector: row => row.nombreEstado, sortable: true },
        // { name: 'PDF', selector: row => row.url_comprobante },
        { name: "Acciones", cell: (row) => (
                    <button
                        onClick={() =>
                            handleOpenPdf(
                            row.url_comprobante
                            )
                        }
                        className="bg-blue-600 text-white px-3 py-1 rounded-md hover:bg-blue-700 text-sm"
                        title="Visualzar PDF"
                    >
                    <FileText size={16} />
                    </button>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
        },
        
    ];

    const handleRowClick = (row) => {
        setSelectedRow(row);
        setIsOpen(true);
    };
  
    const closeModal = () => {
        setIsOpen(false);
        setSelectedRow(null);
    };

    const handleOpenPdf = (url) => {
        setPdfUrl(url);
        setLoadingPdf(true);
        setShowModal(true);
    };
    
    return (
        <div className="p-3">
            <DataTable
                title="Presupuestos"
                columns={columns}
                data={comprobantes}
                pagination
                highlightOnHover
                defaultSortFieldId="fecha"   // 👈 ID que asignamos a la columna
                defaultSortAsc={false}       // 👈 false = descendente
                dense
                customStyles={customStyles}
                // pagination
                // highlightOnHover
                pointerOnHover
                onRowClicked={handleRowClick}            
                paginationComponentOptions={{
                    rowsPerPageText: 'Filas por página',
                    rangeSeparatorText: 'de',
                    selectAllRowsItem: true,
                    selectAllRowsItemText: 'Todos',
                }}
                noDataComponent="No hay datos para mostrar"        
            />
            {/* iNICIA Modal con detalle */}
                {isOpen && selectedRow && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-2xl shadow-lg w-full max-w-4xl p-6">
                        <div className="flex justify-between items-center border-b pb-2 mb-4">
                        <h2 className="text-xl font-semibold text-gray-700">
                            Detalle del comprobante
                        </h2>
                        <button
                            onClick={closeModal}
                            className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
                        >
                            ×
                        </button>
                        </div>

                        <div className="space-y-2">
                        <p><strong>Cliente:</strong> {selectedRow.nomcli}</p>
                        <p><strong>Comprobante:</strong> {selectedRow.comprobante}</p>
                        <p>
                            <strong>Total:</strong>{' '}
                            {/* $ {Number(selectedRow.total).toLocaleString('es-AR', { minimumFractionDigits: 2 })} */}
                            {formatMoneda(selectedRow.total)}
                        </p>
                        <div className="overflow-x-auto">
                            <table className="w-full border border-gray-200 rounded-md mt-2">
                            <thead>
                                <tr className="bg-gray-100 text-gray-700">
                                <th className="py-2 px-3 text-left">Descripción</th>
                                <th className="py-2 px-3 text-right">Cantidad</th>
                                <th className="py-2 px-3 text-right">Precio</th>
                                <th className="py-2 px-3 text-right">IVA</th>
                                <th className="py-2 px-3 text-right">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedRow.items?.map((item, i) => (
                                <tr key={i} className="border-t">
                                    <td className="py-1 px-3">{item.descrip}</td>
                                    <td className="py-1 px-3 text-right">{item.cantidad}</td>
                                    <td className="py-1 px-3 text-right">
                                    {formatMoneda(item.precio)}
                                    </td>
                                    <td className="py-1 px-3 text-right">{item.tasa_iva}%</td>
                                    <td className="py-1 px-3 text-right">
                                    {formatMoneda(item.totalfinal)}
                                    </td>                                    
                                </tr>
                                ))}
                            </tbody>
                            </table>
                        </div>
                        </div>

                        <div className="flex justify-end mt-6">
                        <button
                            onClick={closeModal}
                            className="bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-700"
                        >
                            Cerrar
                        </button>
                        </div>
                    </div>
                    </div>
                )}
            {/* FIN Modal con detalle */}

            {/* Inicia Modal PDF */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
                <div className="bg-white rounded-2xl shadow-lg w-[95%] h-[95vh] max-w-7xl flex flex-col overflow-hidden">
                    {/* Header */}
                    <div className="flex justify-between items-center p-4 border-b bg-gray-100">
                    <h2 className="text-xl font-bold">Vista del Comprobante</h2>
                    <button
                        onClick={() => setShowModal(false)}
                        className="text-gray-600 hover:text-gray-900 text-2xl leading-none"
                    >
                        &times;
                    </button>
                    </div>

                    {/* Contenido */}
                    <div className="flex-1 relative">
                    {loadingPdf && (
                        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 z-10">
                        <div className="flex flex-col items-center">
                            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-solid mb-3"></div>
                            <span className="text-gray-600 font-medium">Cargando Comprobante...</span>
                        </div>
                        </div>
                    )}

                    <iframe
                        src={pdfUrl}
                        title="Vista PDF"
                        className="w-full h-full"
                        onLoad={() => setLoadingPdf(false)}
                    />
                    </div>
                </div>
                </div>
            )}
            {/* Fin Modal PDF */}


        </div>
    );
}

export default TablaComprobantes;
